import { Injectable } from '@angular/core';
import { SurveyService } from '../../../../../core/services/survey/survey.service';
import { QuestionsService } from '../../../../../core/services/survey/questions.service';
import { VariablesService } from '../../../../../core/services/survey/variables.service';

@Injectable({
  providedIn: 'root'
})
export class OfficeSearchWidgetService {
  affiliatedOfficeSearch = false;
  nrdsSearch = false;

  constructor(private surveyService: SurveyService,
              private variablesService: VariablesService,
              private questionsService: QuestionsService) {
  }

  getOffices(isCorporate = false, officeBody?: any, brokerLicenseNumber?: any) {
    this.affiliatedOfficeSearch = false;
    this.nrdsSearch = false;

    this.surveyService.surveyModel.setVariable('office_request_error', null);

    this.variablesService.officeValidated = false;

    const {
      searchFunctionType,
      queryParameters
    } = this.getOfficeSearchFunctionAndQueryParameters(officeBody, isCorporate, brokerLicenseNumber);

    return {searchFunctionType, queryParameters};
  }

  isAffiliate() {
    var affiliate = false;
    if (this.questionsService.licenseHeld != null) {
      if (this.questionsService.licenseHeld.value = 'No') {
        if (this.surveyService.formSource === 'affiliate-application') {
          affiliate = true;
        }
      }
    }
    if (this.surveyService.formSource === 'associate-application') {
      affiliate = true;
    }
    return affiliate;
  }

  isCommercialExchange() {
    return this.surveyService.formSource === 'comex-application';
  }

  isCocieApplication() {
    return this.surveyService.formSource === 'cocie-application';
  }

  getOfficeType() {
    const licenseType = this.questionsService.licenseType?.value || '';
    let officeType = '';
    if (licenseType === 'Broker' || licenseType === 'Salesperson') {
      officeType = 'realtor';
    } else if (licenseType === 'Appraiser' || licenseType === 'Appraiser Trainee') {
      officeType = 'appraiser';
    } else if (licenseType === 'Inspector' || this.isAffiliate()) {
      officeType = 'affiliate';
    } else if (this.isCommercialExchange()) {
      officeType = 'nonmember';
    } else if (this.isCocieApplication()) {
      officeType = 'cocie';
    } else {
      officeType = this.variablesService.searchOfficeType || '';
    }
    return officeType;
  }

  getOfficeSearchFunctionAndQueryParameters(officeBody: any, isCorporate: boolean, brokerLicenseNumber: any) {
    let queryParameters: any = {};
    let role = this.surveyService.surveyModel.getValue('role') || '';
    /*var affiliated_office_search = false;*/

    let searchFunctionType;
    if (this.isSalesPersonOrBrokerForDifferentLicense(brokerLicenseNumber)) {
      if (isCorporate) {
        searchFunctionType = this.processCorporateSearch(queryParameters);
      } else {
        searchFunctionType = this.processFindBrokerOfficesSearch(queryParameters, brokerLicenseNumber);
      }
    } else {
      const membershipType = this.questionsService.membershipType?.value;

      if (officeBody.city) {
        queryParameters.city = officeBody.city;
      }
      queryParameters.state = officeBody.state ? officeBody.state : this.variablesService.state;

      // if application_intention has a value and it's association, then it's an M1 search
      if(this.surveyService.surveyModel.getValue('application_intention') === 'association') {
        queryParameters.business_name = officeBody.office_search;
          searchFunctionType = this.processNonNUANrdsOfficeSearch(queryParameters, officeBody);
      }
      // if application_intention has a value and it's mls, then it's find offices with only MLS offices filter
      else if(this.surveyService.surveyModel.getValue('application_intention')  === 'mls') {
        queryParameters.business_name = officeBody.office_search;
        searchFunctionType = this.processFindOfficesSearch(queryParameters, officeBody);
      }
      else if (!['NUA', 'LMX'].includes(membershipType) && !['DMO', 'EMO'].includes(role)) {
        if (
          (
            (this.isBroker() || this.isAppraiser()) && 
            membershipType !== 'ReinstateLic' &&
            this.surveyService.formSource !== 'change-brokerage' && 
            (
              this.surveyService.formSource !== 'dl-transfer' ||
              (
                this.surveyService.personRelationships && 
                this.surveyService.personRelationships.some((relationship: any) => relationship.is_main_relationship === true && 'ML' === relationship.role_type)  
              )
            )
          ) ||
          (
            this.surveyService.drWorkflow && 
            this.isAffiliate()
          )
        ) {
          // nrds_search = true;
          queryParameters.business_name = officeBody.office_search;
          searchFunctionType = this.processNonNUANrdsOfficeSearch(queryParameters, officeBody);
        } else {
          queryParameters.only_active = true;
          searchFunctionType = this.processFindOfficesSearch(queryParameters, officeBody);
        }
      } else {
        searchFunctionType = this.processFindOfficesSearch(queryParameters, officeBody);
      }

      /*if (qOfficeSearch && qOfficeSearch.value && qOfficeSearch.value.trim().length < 3) {
        survey.setVariable('office_validated', false);
        survey.setVariable('office_request_error', 'The name used for search must 3 characters or more');
        $('#OfficeSearchError').html(survey.getVariable('office_request_error')).show();
        // $.LoadingOverlay('hide');
        return false;
      }*/
    }

    return {searchFunctionType, queryParameters};
  }

  isSalesPersonOrBrokerForDifferentLicense(brokerLicenseNumber: any) {
    const licenseType = this.questionsService.licenseType?.value;
    const licenseNumber = this.questionsService.licenseNumber?.value;

    return this.hasBrokerLicenseNumber(brokerLicenseNumber) &&
      (licenseType === 'Salesperson' ||
        (this.isBroker() &&
          brokerLicenseNumber !== licenseNumber));
  }

  isBroker() {
    return this.questionsService.licenseType?.value === 'Broker';
  }

  isAppraiser() {
    return this.questionsService.licenseType?.value === 'Appraiser';
  }

  isAffiliateLicenseType() {
    return this.questionsService.licenseType?.value === 'Affiliate';
  }

  processCorporateSearch(params: any) {
    this.affiliatedOfficeSearch = false;
    params.corporate_license = this.questionsService.corporateLicenseNumber?.value;
    params.only_active = true;
    return 'findOffices';
  }

  processFindOfficesSearch(params: any, officeBody: any) {
    params.type = this.getOfficeType();
    params.name = officeBody.office_search;
    return 'findOffices';
  }

  processFindBrokerOfficesSearch(params: any, brokerLicenseNumber: any) {
    this.affiliatedOfficeSearch = true;
    const brokerLicense = this.questionsService.affiliatedLicense?.value || brokerLicenseNumber;
    if (this.variablesService.licenseAffiliationsEnabled &&
      this.questionsService.affiliatedLicense?.value) {
      params.broker_license = brokerLicense;
    }
    params.broker_license = brokerLicense;
    return 'findBroker';
  }

  processNonNUANrdsOfficeSearch(params: any, officeBody: any) {
    params.business_name = officeBody.office_search;

    return 'nrdsOffices';
  }

  hasBrokerLicenseNumber(brokerLicenseNumber: any) {
    return brokerLicenseNumber
      && brokerLicenseNumber !== 'undefined';
  }

  isAffiliatedOfficeSearch() {
    this.variablesService.licenseAffiliationsEnabled &&
    this.questionsService.affiliatedLicense?.value;
  }
}
